export default __webpack_public_path__ + "static/media/joys550_no_check_valve_after_meter.240f93b9.png";